const STORAGE_KEY = 'growchat_locale'
const VALID = new Set(['en', 'vi'])

export function getStoredLocale() {
  if (typeof localStorage === 'undefined') return 'en'
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    return VALID.has(v) ? v : 'en'
  } catch {
    return 'en'
  }
}

export function setStoredLocale(lang) {
  if (typeof localStorage === 'undefined' || !VALID.has(lang)) return
  try {
    localStorage.setItem(STORAGE_KEY, lang)
  } catch {
    /* ignore quota / private mode */
  }
}
